import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import html_iway from "./template.iway.html?raw";
import { ShoppingCart, SquareMenu, University, SlidersHorizontal, Rocket } from "lucide-vue-next";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default {
  template: html,
  components: { ShoppingCart, SquareMenu, University, SlidersHorizontal, Rocket },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const router = useRouter();

    const stepDefinitions = [
      { key: "products", path: "/", icon: ShoppingCart, labelKey: "Navigation_Products_Title" },
      { key: "options", path: "/options", icon: SquareMenu, labelKey: "Navigation_Options_Title" },
      { key: "configs", path: "/configs", icon: University, labelKey: "Navigation_Installation_Title" },
      { key: "customerdata", path: "/customerdata", icon: SlidersHorizontal, labelKey: "Navigation_Information_Title" },
      { key: "completion", path: "/completion", icon: Rocket, labelKey: "Navigation_Completion_Title" },
    ];

    const currentStepIndex = computed(() => {
      const path = route.path;
      if (path === "" || path === "/") {
        return 0;
      } else if (path.startsWith("/options")) {
        return 1;
      } else if (path.startsWith("/configs")) {
        return 2;
      } else if (path.startsWith("/customerdata")) {
        return 3;
      } else if (path.startsWith("/completion")) {
        return 4;
      }
      return 0;
    });

    const steps = computed(() =>
      stepDefinitions.map((step, index) => ({
        ...step,
        state: index < currentStepIndex.value ? "done" : index === currentStepIndex.value ? "active" : "todo",
      }))
    );

    // Methods
    const goToStep = (step: (typeof stepDefinitions)[number], index: number) => {
      if (index > currentStepIndex.value) {
        return;
      }
      router.push(step.path);
    };

    return {
      t,
      steps,
      goToStep
    }
  }
}
